<template>
    <div class="kgk-user-company">
        <div v-if="user.companyUpdateRequired" style="margin-top:30px;color:#ff0000;">
            <p>Wir haben das Firmen-System umgestellt – bitte aktualisiere deine Firma! Danke!</p>
        </div>
        <div v-if="user.companyData">
            <div>
                <i>Verknüpfte Firma:</i><br>
            </div>
            <div class="kgk-input-group" style="max-width:300px;margin-left:auto;margin-right:auto;">
                <input type="text" disabled :value="user.companyData.name" name="companyDataName" style="padding-right: 48px">
                <!--<div class="kgk-input-group-append"><a href="#" @click.prevent="editCompany"><i class="fas fa-pencil fa-fw"></i></a></div>-->
                <div class="kgk-input-group-append"><a href="#" style="color:#dd0000" @click.prevent="clearCompany" v-tooltip="'Firma entfernen'"><i class="fas fa-trash fa-fw"></i></a></div>
            </div>
        </div>
        <div v-if="!user.companyData" style="margin-top:8px;">
            <div style="margin-bottom:6px;"><i>Keine Firma verknüpft</i></div>
            <SelectCompany :current-company="user.companyData" @selected="onCompanySelected" />
        </div>
        <div>
            <br/>
            <div v-if="user.company_connection_verified==1"><i style="color:#82C800" class="fas fa-user-check"></i> <i>Du wurdest als Mitarbeiter dieser Firma bestätigt. <i style="color:#82C800" class="fas fa-user-check"></i> <br/>Du darfst dich für die Company Challenge anmelden.</i></div>
            <div v-else><i class="fas fa-user-slash"></i> <i>Du wurdest nicht als Mitarbeiter dieser Firma bestätigt.</i></div>
        </div>
        <div class="spacer-small"></div>
    </div>
</template>

<script>
import user from '../../api/user';

import SelectCompany from '@/components/login/SelectCompany';

export default {
    name: 'UserCompany',
    components: {
        SelectCompany,
    },
    props: {
        user: Object,
    },
    data() {
        return {
            //user: null,
            loading: false,
            error: null,
        }
    },
    computed: {
        isAdmin() {
            return typeof this.user !== 'undefined' && this.user && typeof this.user.admin !== 'undefined' && this.user.admin;
        }
    },
    methods: {
        clearCompany() {
            if(this.user.company_connection_verified==1)
            {
                this.$notify({
                        type: 'error',
                        title: 'Fehler',
                        text: 'Du kannst die Firma aktuell nicht verlassen.',
                        //duration: 8000,
                    });
            }else{
                this.user.companyData = null;
                this.removeUserCompany();
            }
        },
        onCompanySelected(companyData) {
            //console.log('onCompanySelected', JSON.stringify(companyData));
            //this.form.companyData = companyData;
            this.user.companyData = companyData;
            this.updateUserCompany();
        },
        removeUserCompany() {
            user.updateCompany(
                this,
                { companyData: null },
                () => {
                    //console.log(data);

                    this.$notify({
                        type: 'success',
                        title: 'Firma entfernt',
                        text: 'Deine Verknüpfung mit der Firma wurde erfolgreich aufgehoben.',
                        //duration: 8000,
                    });

                    this.$emit('forceRefresh');
                },
                e => {
                    //console.error(e.response.status);
                    if( e.response.status == 400 ) {
                        /*if( typeof e.response.data.field !== 'undefined' ) {
                            // maybe highlight error field
                        }*/

                        this.$notify({
                            type: 'error',
                            title: 'Fehler',
                            text: e.response.data.message
                        });
                        return;
                    }

                    this.$notify({
                        type: 'error',
                        title: 'Es ist ein unbekannter Fehler aufgetreten.',
                        text: 'Bitte versuch es noch einmal.'
                    });
                },
                () => this.loading = false
            );
        },
        updateUserCompany() {
            user.updateCompany(
                this,
                { companyData: this.user.companyData },
                () => {
                    //console.log(data);

                    this.$notify({
                        type: 'success',
                        title: 'Firma verknüpft',
                        text: 'Dein Account wurde erfolgreich mit der Firma verknüpft.',
                        //duration: 8000,
                    });

                    this.$emit('forceRefresh');
                },
                e => {
                    //console.error(e.response.status);
                    if( e.response.status == 400 ) {
                        /*if( typeof e.response.data.field !== 'undefined' ) {
                            // maybe highlight error field
                        }*/

                        this.$notify({
                            type: 'error',
                            title: 'Fehler',
                            text: e.response.data.message
                        });
                        return;
                    }

                    this.$notify({
                        type: 'error',
                        title: 'Es ist ein unbekannter Fehler aufgetreten.',
                        text: 'Bitte versuch es noch einmal.'
                    });
                },
                () => this.loading = false
            );
        }
    },
    mounted() {

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<!--<style scoped lang="scss">
    h3 {
        margin: 40px 0 0;
    }
    ul {
        list-style-type: none;
        padding: 0;
    }
    li {
        display: inline-block;
        margin: 0 10px;
    }
    a {
        color: #42b983;
    }
</style>-->
